import { render, staticRenderFns } from "./Caiji.vue?vue&type=template&id=d30f30c2&scoped=true"
import script from "./Caiji.vue?vue&type=script&lang=js"
export * from "./Caiji.vue?vue&type=script&lang=js"
import style0 from "./Caiji.vue?vue&type=style&index=0&id=d30f30c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30f30c2",
  null
  
)

export default component.exports